import React from 'react';
import Settings from '../settings/Settings';
export default function SettingsPage(){ return <Settings />; }
